import clsx from 'clsx';
import styles from './IconButton.module.scss';

type IconButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type IconButtonVariant =
  | 'primary'
  | 'secondary'
  | 'cta'
  | 'inverted'
  | 'no-bg'
  | 'outline'
  | 'outline-inverted'
  | 'critical';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  label: string;
  size?: IconButtonSize;
  variant?: IconButtonVariant;
  className?: string;
  noShrink?: boolean;
  testId?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const IconButton = ({
  children,
  label,
  size = 'md',
  variant = 'primary',
  className,
  noShrink,
  testId,
  onClick,
  ...props
}: IconButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(styles.button, className, {
      [styles.sizeXs]: size === 'xs',
      [styles.sizeSm]: size === 'sm',
      [styles.sizeMd]: size === 'md',
      [styles.sizeLg]: size === 'lg',
      [styles.sizeXl]: size === 'xl',
      [styles.variantPrimary]: variant === 'primary',
      [styles.variantSecondary]: variant === 'secondary',
      [styles.variantCta]: variant === 'cta',
      [styles.variantInverted]: variant === 'inverted',
      [styles.variantNoBg]: variant === 'no-bg',
      [styles.variantOutline]: variant === 'outline',
      [styles.variantOutlineInverted]: variant === 'outline-inverted',
      [styles.variantCritical]: variant === 'critical',
      [styles.noShrink]: noShrink,
    })}
    data-testid={testId}
    {...props}
  >
    <span className="sr-only">{label}</span>
    {children}
  </button>
);
